import React, { useRef } from "react";
import { useValidateIsNotEmptyString } from "formvalidation/hooks";
import { TextArea } from "components/Atoms/formInputs/TextArea";

interface Props {
  value: string
  onChange: (value: string) => void
  maxLength: number
  onBlur?: () => void
  onCtrlEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  rows?: number
  validatorKey: string
}

const RequiredTextAreaInput = (props: Props) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const validation = useValidateIsNotEmptyString({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    ref: textAreaRef,
  })

  return <TextArea
    placeholder={props.placeholder}
    rows={props.rows || 6}
    ref={textAreaRef}
    value={props.value}
    onChange={props.onChange}
    maxLength={props.maxLength}
    onBlur={props.onBlur}
    onCtrlEnter={props.onCtrlEnter}
    onEsc={props.onEsc}
    focusOnMount={props.focusOnMount}
    disabled={props.disabled}
    error={validation.error.hasError}
  />;
}
export default RequiredTextAreaInput;